import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import { getStorageData, setStorageData } from "utils/helper";
import {
  pageType,
  DefaultPage,
  TablePageSize,
  DOMAIN_CLINKS,
} from "constants/app";
import { agencySearch, pathwaySubPathwayList } from "apiServices/app";
import HeaderComponent from "components/Layout/HeaderComponent";
import LeftSideFilterComponent from "components/SearchOrgList/LeftSideFilterComponent";
import OrgDetailsComponent from "components/SearchOrgList/OrgDetailsComponent";
// import TopHeaderSearchComponents from "components/TopHeaderSearchComponents";
import FooterComponent from "components/Layout/FooterComponent";
import classNames from "classnames";
import { useStyles } from "../SearchOrgList/styles";
import {
  RegionsOption,
  PrisonsOption,
  ProbationRegionsOption,
  AreaCoveredOption,
  TypeOfOrganisationOption,
  CustodyOrCommunityOption,
  RaciallyMinoritisedOption,
  SpecialistOrganisationOption,
} from "./constants";
import axios from "axios";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { FaFilter } from "react-icons/fa";

const SearchClinksOrgList = (props) => {
  const classes = useStyles(props);
  const { formData, setFormData } = props;
  const domain = getStorageData("domain");
  const domain_status = DOMAIN_CLINKS === domain ? true : false;
  const [agencyData, setAgencyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(DefaultPage);
  const [limit, setLimit] = useState(TablePageSize);
  const [totalPages, setTotalPages] = useState(DefaultPage);
  const [totalRecord, setTotalRecord] = useState();
  const [loader, setLoader] = useState(false);
  const [listStatus, setListStatus] = useState(true);
  const [searchStatus, setSearchStatus] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const targeOption = getStorageData("target_option");
  const countyOption = getStorageData("county_option");
  const pathwayOption = getStorageData("pathway");

  const [filterAllData, setFilterAllData] = useState({
    regions: RegionsOption,
    prisons: PrisonsOption,
    probation_regions: ProbationRegionsOption,
    area_covered: AreaCoveredOption,
    type_of_organisation: TypeOfOrganisationOption,
    custody_or_community: CustodyOrCommunityOption,
    // racially_minoritised: RaciallyMinoritisedOption,
    specialist_organisation: SpecialistOrganisationOption,
    target_group:
      targeOption && Object.keys(targeOption).length > 0 ? targeOption : [],
    county:
      countyOption && Object.keys(countyOption).length > 0 ? countyOption : [],
    pathway:
      pathwayOption && Object.keys(pathwayOption).length > 0
        ? pathwayOption
        : [],
  });
  const [filterData, setFilterData] = useState({
    regions: RegionsOption,
    prisons: PrisonsOption,
    probation_regions: ProbationRegionsOption,
    area_covered: AreaCoveredOption,
    type_of_organisation: TypeOfOrganisationOption,
    custody_or_community: CustodyOrCommunityOption,
    // racially_minoritised: RaciallyMinoritisedOption,
    specialist_organisation: SpecialistOrganisationOption,
    target_group:
      targeOption && Object.keys(targeOption).length > 0 ? targeOption : [],
    county:
      countyOption && Object.keys(countyOption).length > 0 ? countyOption : [],
    pathway:
      pathwayOption && Object.keys(pathwayOption).length > 0
        ? pathwayOption
        : [],
  });

  const onSearchClick = () => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
    getAgencySearchData();
  };
  const getAgencySearchData = (sourceToken) => {
    // let sourceToken = axios.CancelToken.source();

    setSearchStatus(false);
    setStorageData("user_data", formData);
    setLoader(true);
    agencySearch(
      {
        ...formData,
        page: currentPage,
        limit: limit,
        domain_status: domain_status,
      },
      sourceToken,
    )
      .then(({ data: { data, total_record, total_page }, success }) => {
        if (success === "true") {
          setAgencyData(data);
          setTotalPages(total_page);
          setTotalRecord(total_record);
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      })
      .finally(() => {});
    return () => sourceToken.cancel();
  };

  const getSearchAllData = () => {
    let sourceToken = axios.CancelToken.source();
    pathwaySubPathwayList(
      {
        status: true,
        domain_status: domain_status,
      },
      sourceToken,
    )
      .then(({ data, success }) => {
        if (success === "true") {
          const result_target = data?.target_group?.length
            ? data.target_group.map((val, i) => {
                return {
                  value: val.id,
                  label: val.name,
                  text: val.name,
                };
              })
            : [];

          const result_county = data?.county?.length
            ? data.county.map((val, i) => {
                return {
                  value: val.id,
                  label: val.name,
                  text: val.name,
                };
              })
            : [];

          const result_pathway = data?.pathway?.length
            ? data.pathway.map((val, i) => {
                return {
                  value: val.id,
                  label: val.name,
                  text: val.name,
                };
              })
            : [];
          setFilterData({
            ...filterData,
            pathway: result_pathway,
            target_group: result_target,
            county: result_county,
          });
          const local_authority = data?.local_authority;
          setStorageData("pathway", result_pathway);
          setStorageData("target_option", result_target);
          setStorageData("county_option", result_county);
          setStorageData("local_authority", local_authority);
        }
      })
      .catch((error) => {})
      .finally();
    return () => sourceToken.cancel();
  };

  useEffect(() => {
    getSearchAllData();
  }, []);

  useEffect(() => {
    const sourceToken = axios.CancelToken.source();

    const timer = setTimeout(() => {
      getAgencySearchData(sourceToken);
    }, 500);

    return () => {
      clearTimeout(timer);
      sourceToken.cancel("Cancelled due to new request");
    };
  }, [formData, currentPage, limit]);

  // useEffect(() => {
  //   return getAgencySearchData();
  // }, [formData, currentPage, limit]);

  const isMobileFilter =
    formData?.pathway?.length ||
    formData?.regions?.length ||
    formData?.prisons?.length ||
    formData?.probation_regions?.length ||
    formData?.area_covered?.length ||
    formData?.type_of_organisation?.length ||
    formData?.custody_or_community?.length ||
    // formData?.racially_minoritised?.length ||
    formData?.specialist_organisation?.length ||
    formData?.target_group?.length ||
    formData?.county?.length
      ? true
      : false;

  return (
    <>
      <div
        className={classNames(
          classes.orglist__page,
          "orglist__pageCommon orglist__clinks",
        )}
      >
        <HeaderComponent
          className="bg-brand-primary w-100"
          isPage={pageType.list}
          {...props}
        />
        <section className="orgl__section">
          <Container fluid="fluid">
            <Row className="orgl__list">
              <Col className="orgl__left position-relative" lg={3}>
                <LeftSideFilterComponent
                  className="sticky-md-top"
                  filterData={filterData}
                  setFilterData={setFilterData}
                  formData={formData}
                  setFormData={setFormData}
                  agencyData={agencyData}
                  filterAllData={filterAllData}
                  setFilterAllData={setFilterAllData}
                  isMobileView={isMobileView}
                  setIsMobileView={setIsMobileView}
                  onSearchClick={onSearchClick}
                />
              </Col>
              <Col className="orgl__right" lg={9}>
                <OrgDetailsComponent
                  formData={formData}
                  setFormData={setFormData}
                  agencyData={agencyData}
                  totalRecord={totalRecord}
                  totalPages={totalPages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  loader={loader}
                  domain_status={domain_status}
                  listStatus={listStatus}
                  setListStatus={setListStatus}
                  limit={limit}
                  setLimit={setLimit}
                />
              </Col>
            </Row>
          </Container>
        </section>
        <div className="mob__filter">
          <div className="mob__inner d-flex align-items-center justify-content-center">
            <ButtonComponent
              variant="dark"
              title="Filter"
              className={`${
                isMobileFilter ? "mon__filtered" : ""
              } position-relative`}
              onClick={() => {
                var root = document.getElementsByTagName("html")[0];
                root.setAttribute("class", "filter_overlap");
                setIsMobileView(true);
              }}
            >
              Filter
              <FaFilter className="ms-2" />
            </ButtonComponent>
          </div>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};
SearchClinksOrgList.propTypes = {
  history: propTypes.object,
};
export default SearchClinksOrgList;
